// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"03e08172926d1b99a31c","966":"53726dfbe9c975c894bb"}[chunkId] + ".js";
};